import {Action, createReducer, on} from '@ngrx/store';

import {OnSSEConnected, OnSSEDisconnected} from '../core/actions/notification.action';

export interface NotificationState {
  isSSEConnected: boolean;
}

/**
 * Keep track of SSE connection status of logged in paymasters for now.
 * In the future, we can persist all incoming SSE messages if needed.
 */
export const initialState: NotificationState = {
  isSSEConnected: false,
};

export const reducer = createReducer(
  initialState,
  on(OnSSEConnected, (state) => ({
    ...state,
    isSSEConnected: true,
  })),
  on(OnSSEDisconnected, (state) => ({
    ...state,
    isSSEConnected: false,
  })),
);

export function notificationReducer(state = initialState, action: Action): NotificationState {
  return reducer(state, action);
}
